import {useCallback, useEffect} from 'react';
import {useNavigation} from '@react-navigation/native';
import {useAppSelector} from '../../../redux';
import {holderProfileSelector} from '../../../redux/selectors/profile';
import {hasCardReissueEsiaContext} from '../../../shared/storage/cardReissueEsia';
import {AuthorizeEsiaResponsePayload} from '../../../shared/models/api/authorizeEsiaResponsePayload';
import {Screens} from '../../../shared/routing';
import {useModal} from '../../../shared/components/modal';
import {shouldActivateCardFromEsia} from '../../login/cardActivation/decision';

type Params = {
  isFocused: boolean;
  isAuthorized: boolean;
  canReissueCard: boolean;
  esiaRegInfo: AuthorizeEsiaResponsePayload | null;
  cancelEsia: () => Promise<void>;
};

export const useCardReissueGuards = ({isFocused, isAuthorized, canReissueCard, esiaRegInfo, cancelEsia}: Params) => {
  const navigation = useNavigation();
  const modals = useModal();
  const holder = useAppSelector(holderProfileSelector());

  const redirectBack = useCallback(() => {
    void cancelEsia();
    modals.clear();
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate(Screens.Login as never);
  }, [cancelEsia, modals, navigation]);

  useEffect(() => {
    if (!isFocused || hasCardReissueEsiaContext()) {
      return;
    }
    if (shouldActivateCardFromEsia(esiaRegInfo)) {
      return;
    }
    if (!isAuthorized) {
      void cancelEsia();
      modals.clear();
      navigation.navigate(Screens.Login as never);
      return;
    }
    if (!holder) {
      return;
    }
    if (!canReissueCard) {
      redirectBack();
    }
  }, [cancelEsia, canReissueCard, esiaRegInfo, holder, isAuthorized, isFocused, modals, navigation, redirectBack]);

  return {redirectBack};
};
